<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Stop Game</span>
  <ng-container dialog-content>
    <div class="red-text">
      <p>
        This will immediately end the game and refund <strong>all</strong> tickets in the current draw. This cannot be undone.
      </p>
      <p>
        Approximately {{ totalStripeFees | formatCurrency }} in Stripe fees have been accrued so far in the current draw. You will still be required to pay this to Stripe if you end the game now.
      </p>
    </div>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
